/// <reference path="../services/logservice.ts" />
/// <reference path="../screenmode.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../services/navigationhelperservice.ts" />
/// <reference path="../services/formhelperservice.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../services/globalsettingsservice.ts" />
/// <reference path="../services/usermessagesservice.ts" />
/// <reference path="../isessionstorage.d.ts" />
/// <reference path="../ilocalstorage.d.ts" />
/// <reference path="icontroller.d.ts" />
/// <reference path="../messageboxconfig.ts" />

module App.Common.Controllers {
	'use strict';

	export abstract class ControllerBase implements Controllers.IController, Controllers.IInitialize {

		public $rootScope: angular.IRootScopeService;
		public $q: angular.IQService;
		public $timeout: angular.ITimeoutService;
		public $document: duScroll.IDocumentService;
		public $filter: any;
		public $stateParams: angular.ui.IStateParamsService;
		public $sessionStorage: Common.ISessionStorage;
		public $localStorage: Common.ILocalStorage;
		public $uibModal: angular.ui.bootstrap.IModalService;
		public $location: angular.ILocationService;
		public $window: angular.IWindowService;
		public $state: angular.ui.IStateService;
		public api: Common.Services.ApiService;
		public users: Common.Services.UsersService;
		public userMessages: Common.Services.UserMessagesService;
		public errorHandler: Common.Services.ErrorHandlerService;
		public authentication: Common.Services.AuthenticationService;
		public globalSettings: Common.Services.GlobalSettingsService;
		public formHelper: Common.Services.FormHelperService;
		public modal: Common.Services.ModalService;
		public navigationHelper: Common.Services.NavigationHelperService;
		public analytics: any;
        public logger: Common.Services.LogService;

		public title = 'Untitled Screen';
		public titleSecondary = '';
		public warnOnUnsavedChanges = true;
		public screenMode = ScreenMode.Edit;

		constructor(public $injector: angular.auto.IInjectorService) {

			this.$rootScope = $injector.get<angular.IRootScopeService>('$rootScope');
			this.$q = $injector.get<angular.IQService>('$q');
			this.$timeout = $injector.get<angular.ITimeoutService>('$timeout');
			this.$document = $injector.get<duScroll.IDocumentService>('$document');
			this.$filter = $injector.get<angular.IFilterService>('$filter');
			this.$sessionStorage = $injector.get<Common.ISessionStorage>('$sessionStorage');
			this.$localStorage = $injector.get<Common.ILocalStorage>('$localStorage');
			this.$uibModal = $injector.get<angular.ui.bootstrap.IModalService>('$uibModal');
			this.$location = $injector.get<angular.ILocationService>('$location');
			this.$window = $injector.get<angular.IWindowService>('$window');
			this.$state = $injector.get<angular.ui.IStateService>('$state');
			this.$stateParams = $injector.get<angular.ui.IStateParamsService>('$stateParams');
			this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
			this.users = $injector.get<Common.Services.UsersService>('app.common.services.usersService');
			this.userMessages = $injector.get<Common.Services.UserMessagesService>('app.common.services.userMessagesService');
			this.errorHandler = $injector.get<Common.Services.ErrorHandlerService>('app.common.services.errorHandlerService');
			this.authentication = $injector
				.get<Common.Services.AuthenticationService>('app.common.services.authenticationService');
			this.globalSettings = $injector
				.get<Common.Services.GlobalSettingsService>('app.common.services.globalSettingsService');
			this.formHelper = $injector.get<Common.Services.FormHelperService>('app.common.services.formHelperService');
			this.modal = $injector
				.get<Common.Services.ModalService>('app.common.services.modalService');
			this.navigationHelper = $injector
				.get<Common.Services.NavigationHelperService>('app.common.services.navigationHelperService');
			this.analytics = $injector.get<any>('Analytics');
			this.logger = $injector.get<Common.Services.LogService>('app.common.services.logService');

		}

		public abstract initialize(): angular.IPromise<any>;

		public controllerName() {
			return this.constructor.toString().match(/\w+/g)[1];
		}

		public viewName(instance: number = null) {
			var viewName = this.controllerName().replace('Controller', 'View');
			if (instance != null) {
				viewName += viewName + '_' + instance.toString();
			}
			return viewName;
		}

		public isReadonly() {
			return this.screenMode === ScreenMode.Readonly;
		}

		public noAccess() {
			return this.screenMode === ScreenMode.NoAccess;
		}

		public isEditable() {
			return this.screenMode === ScreenMode.Edit;
		}

		public hasUnsavedChanges() {
			return this.isEditable() && this.warnOnUnsavedChanges && this.dirty();
		}

		protected abstract mainForm(): angular.IFormController;

		protected setPristine() {
			var form = this.mainForm();
			if (!form) { return; }
			form.$setPristine();
		}

		protected dirty() {
			var form = this.mainForm();
			return form && form.$dirty;
		}

		public canSave(): boolean {
			return this.mainForm().$dirty && !this.isReadonly();
		}

		/**
		 * Get the session information for the view of the controller type provided.
		 * The session information is used to store search and result data.
		 * @param model = Provide a new instance of the model data to store in this session
		 * @param instance = The instance number of this view. Most views have only one instance so this can be null or zero. Some views may be used in different modes - each mode will have different storage requirements and hence instance numbers to track these separate stores.
		 */
		protected getViewSessionStorage<T>(model: T, instance: number = null) {
			var defaults = {};
			defaults[this.viewName(instance)] = model;
			this.$sessionStorage.$default(defaults);
			return this.$sessionStorage[this.viewName(instance)];
		}

		protected getViewLocalStorage<T>(model: T) {
			var defaults = {};
			defaults[this.viewName()] = model;
			this.$localStorage.$default(defaults);
			return this.$localStorage[this.viewName()];
		}
		
	}

}